<app-smart-fix-voice-chat
  [interactionMode]="interactionMode()"
  [chatHistory]="chatHistory()"
  [sessionId]="sessionId() ?? ''"
  [planNumber]="planNumber()"
  [claimBundleData]="claimBundleData()"
  [V2VisLoading]="V2VisLoading()"
  (addMessage)="addMessage.emit($event)"
  (goToRepairBooking)="goToRepairBooking.emit()"
  (switchToTextMode)="interactionModeChanged.emit($event)"
/>

<div class="chat-container" [class.hidden]="isNovaSonicSelected">
  @if (showTopGradient) {
    <span class="chat-scroll-gradient"></span>
  }
  <div
    #scrollContainer
    class="scrollable-chat"
    [ngClass]="{
      'chat-separator': enableVoiceCapture && !vm.chatLoading,
    }"
  >
    <h2 class="heading-1" [innerHTML]="vm.title"></h2>

    <div class="chat-messages">
      @for (chat of vm.chatHistory; track index; let index = $index) {
        <section [class]="chat.role">
          @if (chat.role === 'agent') {
            @if (this.vm.showGreeting && index <= 1) {
              <p class="body bold greeting">Hi {{ formattedUserName }} 👋</p>
            }
            <app-smart-fix-model-response
              [content]="chat.content.message"
              (typingProgress)="onTypingProgress()"
            ></app-smart-fix-model-response>
          }

          @if (chat.content.type !== 'image' && chat.role === 'user') {
            <p class="message body history-item" qmEncrypt>
              {{ chat.content.message }}
            </p>
          }

          @if (chat.content.type === 'image' && chat.content.image?.data) {
            <div class="user-attached-image user">
              <button
                type="button"
                class="chat-image-btn"
                (click)="chat.content.image && onAttachedImageClick(chat.content.image)"
                tabindex="0"
              >
                <span class="chat-image-overlay">
                  <i class="fa-light fa-expand"></i>
                </span>
                <img
                  [src]="'data:' + chat.content.image?.mimeType + ';base64,' + chat.content.image?.data"
                  [alt]="chat.content.image?.filename"
                  class="user-attached-image message body history-item chat-image-hover"
                />
              </button>
            </div>
          }
        </section>
      }

      @if (this.showSafetyCheck) {
        <div class="image-prompt-buttons">
          <app-button
            dataLabel="safety-check-burning-smell"
            (click)="onSafetyCheckAnswer(true)"
            [buttonOptions]="{ variant: 'secondary' }"
            >Yes</app-button
          >
          <app-button
            dataLabel="safety-check-burning-smell"
            (click)="onSafetyCheckAnswer(false)"
            [buttonOptions]="{ variant: 'secondary' }"
            >No</app-button
          >
        </div>
      }

      @if (this.showFireQuestion) {
        <div class="image-prompt-buttons">
          <app-button
            dataLabel="safety-check-fire"
            (click)="onFireCheckAnswer(true)"
            [buttonOptions]="{ variant: 'secondary' }"
            >Yes</app-button
          >
          <app-button
            dataLabel="safety-check-fire"
            (click)="onFireCheckAnswer(false)"
            [buttonOptions]="{ variant: 'secondary' }"
            >No</app-button
          >
        </div>
      }

      @if (this.enableImageAttachment) {
        <smart-fix-image-attach-component
          #imageAttachComponent
          [style.display]="this.showAttachImageTile && this.attachedImage === null ? 'block' : 'none'"
          (imageAttached)="onImageAttached($event)"
        ></smart-fix-image-attach-component>
      }

      @if (vm.chatLoading) {
        <section class="agent text--left">
          <app-loading-dots></app-loading-dots>
        </section>
      }
    </div>
  </div>

  <div class="chat-input">
    <div
      class="input-wrapper"
      [class.has-image]="attachedImage !== null"
      [class.keyboard-focus]="showInputWrapperFocus"
      (focusin)="onInputWrapperFocus()"
      (focusout)="onInputWrapperBlur()"
    >
      <div class="container">
        <textarea
          #chatInput
          fadeInUp
          name="message"
          rows="1"
          placeholder="Write here"
          (keydown.enter)="onEnter($event)"
          (input)="autoResize()"
          [(ngModel)]="chatMessage().content"
          [disabled]="isTextInputDisabled"
          data-testid="chat-input"
          qmEncrypt
        ></textarea>
      </div>
      @if (this.attachedImage) {
        <div class="attached-image-container">
          <span class="chat-image-overlay" (click)="onAttachedImageClick()">
            <i class="fa-light fa-expand"></i>
          </span>
          <img
            [src]="attachedImage.preview"
            class="attached-image-preview"
            alt="preview"
            (click)="onAttachedImageClick()"
          />
          <div class="image-actions">
            <button
              (keydown.enter)="amendImage('change', $event)"
              (click)="amendImage('change')"
              [title]="'Change image'"
            >
              <i class="fa-light fa-image fa-lg"></i>
            </button>
            <button
              (keydown.enter)="amendImage('remove', $event)"
              (click)="amendImage('remove')"
              [title]="'Remove image'"
            >
              <i class="fa-light fa-xmark fa-lg"></i>
            </button>
          </div>
        </div>
      }
      <div class="action-icon-container">
        @if (this.shouldShowVoiceCaptureToggle) {
          <button
            type="button"
            class="icon-button"
            (click)="voiceCaptureToggle()"
            (keydown.enter)="voiceCaptureToggle()"
            aria-label="voice-capture"
          >
            <i
              class="fa-light fa-lg"
              [title]="this.isListening ? 'Pause message' : 'Voice capture'"
              [ngClass]="this.isListening ? 'fa-pause recording-voice-icon' : 'fa-microphone'"
            >
            </i>
          </button>
        }
        <button
          type="button"
          class="icon-button"
          data-testid="send-message-icon"
          (click)="onEnter($event)"
          (keydown.enter)="onEnter($event)"
          [class.disabled]="vm.chatLoading"
          title="Send"
        >
          <i class="fa-light fa-arrow-up fa-lg send-icon"></i>
        </button>
      </div>
    </div>
  </div>
</div>
